module.exports = __webpack_public_path__ + "img/RACKS.4fcac5cf.png";